export const state = {
  // product: undefined,
  // products: []
  horaire: {},
  horaires: [],
  pagination: {},

};
